/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { call, put, SagaReturnType, takeLeading } from "redux-saga/effects";
import { formatError } from "utils/errorHelper";
import api from "_config/api";

export interface CriarManifestacaoRequest {
  respostas: {
    titulo: string;
    descricao: string;
    tipoManifestacao: number;
    latitude: number;
    longitude: number;
    image: File;
  };
  onSuccess?: (idSolicitacao: string) => void;
}

interface State {
  isRequesting: boolean;
  errors: string[];
}

const initialState: State = {
  isRequesting: false,
  errors: []
};

const criarManifestacaoSlice = createSlice({
  name: "ouvidoria.manifestacoes@criarManifestacao",
  initialState,
  reducers: {
    criarManifestacaoRequest: (
      state,
      action: PayloadAction<CriarManifestacaoRequest>
    ): void => {
      state.isRequesting = true;
      state.errors = [];
    },
    criarManifestacaoSuccess: (state): void => {
      state.isRequesting = false;
    },
    criarManifestacaoFailed: (state, action: PayloadAction<string[]>): void => {
      state.isRequesting = false;
      state.errors = action.payload;
    }
  }
});

function* sagaFunction(params: {
  type: string;
  payload: CriarManifestacaoRequest;
}) {
  const { onSuccess, respostas } = params.payload;

  const formData = new FormData();

  formData.append("titulo", respostas.titulo);
  formData.append("descricao", respostas.descricao);
  formData.append("tipoManifestacao", String(respostas.tipoManifestacao));
  formData.append("latitude", String(respostas.latitude));
  formData.append("longitude", String(respostas.longitude));
  formData.append("image", respostas.image);

  try {
    const response: SagaReturnType<typeof api> = yield call(
      api.post,
      `api/v1/cidadao/ouvidoria/manifestacoes`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    const { data } = response;
    if (onSuccess) onSuccess(data);

    yield put(criarManifestacaoSuccess());
  } catch (error) {
    yield put(criarManifestacaoFailed(formatError(error)));
  }
}

export const {
  criarManifestacaoRequest,
  criarManifestacaoSuccess,
  criarManifestacaoFailed
} = criarManifestacaoSlice.actions;

export const { reducer } = criarManifestacaoSlice;
export const saga = takeLeading(criarManifestacaoRequest.type, sagaFunction);
